<template>
    <div class="modal-sms-input">
        <common-sms-input
            v-bind:sms-verification-props="smsVerificationProps"
            v-on:submit="onSubmit"
        />
    </div>
</template>

<script>
export default {
    name: 'modal-sms-input',
    props: {
        smsVerificationProps: {
            type: Object,
            default: null,
        },
    },
    methods: {
        onSubmit(code) {
            this.$emit('submit', code);
            this.$store.commit('modals/pop');
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.modal-sms-input {
    .modal();
    position: relative;

    @media @media-sm-down {
        padding: 16px 16px 24px;
    }
}
</style>
